import axios from "axios";

const state = {
  sidebar: {
    opened: false
  },
  testval: "test1",
  config: {
    palette: {
      primary: "#4ae387",
      danger: "#e34a4a",
      info: "#4ab2e3",
      success: "#db76df",
      warning: "#f7cc36",
      white: "#fff",
      black: "#000",
      fontColor: "#34495e",
      transparent: "transparent",
      lighterGray: "#ddd"
    }
  },
  isLoading: true,
  loadEntreprise: false,
  statEntreprises: null,
  listeCCN: []
};

const mutations = {
  updateListeCCN(state, value) {
    state.listeCCN = value;
  },
  updateStats(state, value) {
    state.statEntreprises = value;
  },
  setTestVal(state, value) {
    state.testval = value;
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setLoadEntreprise(state, isLoading) {
    state.loadEntreprise = isLoading;
  }
};

const actions = {
  async loadListeCCN({ commit, state }) {
    try {
      let resp = await axios.get("/api/ccns-list");

      let ccnOptions = resp.data;
      ccnOptions.splice(1, 0, { idccn: 99, displayName: "-" });
      commit("updateListeCCN", resp.data);
    } catch (err) {
      commit("error updating liste ccn");
      throw new Error(err);
    }
  },
  async udateStats({ commit, state }) {
    try {
      let resp = await axios.get("/api/stats-menu");
      commit("updateStats", resp.data);
    } catch (err) {
      commit("error updating statistics");
      throw new Error(err);
    }
  }
};

export default {
  state,
  mutations,
  actions
};
